import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { Text, spacing } from '@retailer-platform/shared-components'
import { SelectableCell } from 'legacy/components/Forms'
import ContentExampleImage from 'assets/content-example-image.svg'
import ContentExampleText from 'assets/content-example-text.svg'
import { useDashMessages } from 'intl/intl.hooks'
import { bannerTypes } from 'domains/merchandising/constants/heroBanner.constants'
import { type HeroBannerBannerType } from 'domains/merchandising/types/heroBanner.types'
import { isImagebanner, isTextBanner } from 'domains/merchandising/utils/heroBannerUtils'

const selectorContainer = css({
  display: 'flex',
  justifyContent: 'space-between',
})

const cardStyles = css({
  // This currently isn't a prop in SelectableCell, so using the same padding here
  padding: '13px',
})

const textStyles = css({
  margin: 0,
})

const imageStyles = css({
  display: 'block',
  marginBottom: spacing.X16,
  width: '100%',
})

const cellStyles = {
  height: '300px',
  margin: '0',
}

export interface HeroBannerCreateTypeSelectorProps {
  onBannerSelect: (value: HeroBannerBannerType) => void
  bannerType: HeroBannerBannerType
}

export const HeroBannerCreateTypeSelector: FunctionComponent<HeroBannerCreateTypeSelectorProps> = ({
  onBannerSelect,
  bannerType,
}) => {
  const messages = useDashMessages({
    imageTitle: 'merchandising.hero-banners.page.create.selector.image.title',
    imageDescription: 'merchandising.hero-banners.page.create.selector.image.description',
    textTitle: 'merchandising.hero-banners.page.create.selector.text.title',
    textDescription: 'merchandising.hero-banners.page.create.selector.text.description',
  })

  return (
    <div css={selectorContainer}>
      <SelectableCell
        containerProps={cellStyles}
        isSelected={isTextBanner(bannerType)}
        onChange={() => onBannerSelect(bannerTypes.text as HeroBannerBannerType)}
        title={messages.textTitle}
      >
        <div css={cardStyles}>
          <img src={ContentExampleText} css={imageStyles} />
          <Text styles={textStyles}>{messages.textDescription}</Text>
        </div>
      </SelectableCell>
      <SelectableCell
        containerProps={cellStyles}
        isSelected={isImagebanner(bannerType)}
        onChange={() => onBannerSelect(bannerTypes.image as HeroBannerBannerType)}
        title={messages.imageTitle}
      >
        <div css={cardStyles}>
          <img src={ContentExampleImage} css={imageStyles} />
          <Text styles={textStyles}>{messages.imageDescription}</Text>
        </div>
      </SelectableCell>
    </div>
  )
}
